/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindAdminOrganizationSuppliersResponse,
  FindAdminOrganizationSuppliersarams,
  FindAdminOrganizationSuppliersParams,
  FindAdminOrganizationSuppliers,
} from "../types/FindAdminOrganizationSuppliers.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findAdminOrganizationSuppliersKey = (
  organizationId:
    | FindAdminOrganizationSuppliersarams["organizationId"]
    | undefined,
  params?: FindAdminOrganizationSuppliersParams
) =>
  [
    {
      url: "/v1/admin/organizations/:organizationId/suppliers",
      params: { organizationId: organizationId },
    },
    ...(params ? [params] : []),
  ] as const

export type FindAdminOrganizationSuppliersKey = ReturnType<
  typeof findAdminOrganizationSuppliersKey
>

/**
 * @summary Find admin organization suppliers
 * {@link /v1/admin/organizations/:organizationId/suppliers}
 */
export async function findAdminOrganizationSuppliers(
  organizationId: FindAdminOrganizationSuppliersarams["organizationId"],
  params?: FindAdminOrganizationSuppliersParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindAdminOrganizationSuppliersResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/admin/organizations/${organizationId}/suppliers`,
    params,
    ...requestConfig,
  })
  return res
}

export function findAdminOrganizationSuppliersOptions(
  organizationId:
    | FindAdminOrganizationSuppliersarams["organizationId"]
    | undefined,
  params?: FindAdminOrganizationSuppliersParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findAdminOrganizationSuppliersKey(organizationId, params)
  return queryOptions<
    ResponseConfig<FindAdminOrganizationSuppliersResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindAdminOrganizationSuppliersResponse>,
    typeof queryKey
  >({
    enabled: !!organizationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findAdminOrganizationSuppliers(organizationId!, params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find admin organization suppliers
 * {@link /v1/admin/organizations/:organizationId/suppliers}
 */
export function useFindAdminOrganizationSuppliers<
  TData = ResponseConfig<FindAdminOrganizationSuppliersResponse>,
  TQueryData = ResponseConfig<FindAdminOrganizationSuppliersResponse>,
  TQueryKey extends QueryKey = FindAdminOrganizationSuppliersKey,
>(
  organizationId:
    | FindAdminOrganizationSuppliersarams["organizationId"]
    | undefined,
  params?: FindAdminOrganizationSuppliersParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindAdminOrganizationSuppliersResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findAdminOrganizationSuppliersKey(organizationId, params)

  const query = useQuery(
    {
      ...findAdminOrganizationSuppliersOptions(organizationId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
